import { render } from "./ContentCut.vue?vue&type=template&id=6e9a91f6"
import script from "./ContentCut.vue?vue&type=script&lang=js"
export * from "./ContentCut.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ContentCut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e9a91f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e9a91f6', __exports__)) {
    api.reload('6e9a91f6', __exports__)
  }
  
  module.hot.accept("./ContentCut.vue?vue&type=template&id=6e9a91f6", () => {
    api.rerender('6e9a91f6', render)
  })

}


export default __exports__